import React from "react";
import Translations from "../../services/translation";
import ModalLayout from "../../layouts/modal";
import Events from "../../services/events.service";

const logoutConfirmationModal = (props) => {
    const strings = Translations["keys"][Translations.activeLang];
    return (
        <ModalLayout icon={true} size="small" close={false}>
            <h2>{strings["LOGOUT_CONFIRMATION_QUESTION"]}</h2>
            <div className="vmo-modal-actions">
                <button
                    type="button"
                    className="vmo-button vmo-button-round vmo-button-wide vmo-button-red"
                    onClick={(btn) => {
                        Events.when_user_interacts_with_logout_popup_buttons(strings["YES"]);
                        props.confirmLogout("confirm");
                    }}
                >
                    {strings["YES"]}
                </button>
                <button
                    type="button"
                    className="vmo-button vmo-button-round vmo-button-wide vmo-button-white-bordered"
                    onClick={(btn) => {
                        Events.when_user_interacts_with_logout_popup_buttons(strings["CANCEL"]);
                        props.confirmLogout("no");
                    }}
                >
                    {strings["CANCEL"]}
                </button>
            </div>
        </ModalLayout>
    );
};
export default logoutConfirmationModal;
